import {ClsGuardarConceptosPartida, ClsGuardarConceptosPartidaDetalle} from "./cls-concepto";

export class ClsArbolPartida {
  IdPartidaPadre?: bigint;
  IdPartidaPadreS?: string;
  IdPresupuestoPartida?: bigint;
  IdPresupuestoPartidaS?: string;
  // Marca = false;
  PartidaPadre?: string;
  Partida: string;
  Renglon?: number;
  PartidaAuxiliar?: string;
  DescripcionPartida?: string;
  DescripcionPartidaLarga: string;
  MetrosCuadrados?: number;
  PartidaWBS: string;
  CostoMoneda1: number;
  PrecioMoneda1: number;
  CostoMoneda2: number;
  PrecioMoneda2: number;
  CostoMoneda1XM2?: number;
  PrecioMoneda1XM2?: number;
  CostoMoneda2XM2?: number;
  PrecioMoneda2XM2?: number;
  ImporteCosto1?: number;
  ImporteCosto2?: number;
  JsonConceptos?: any;
}

export class ClsArbolPartidaNiveles {
  IdPartidaPadre?: bigint;
  IdPresupuestoPartida?: bigint;
  Partida: string;
  DescripcionPartida?: string;
  DescripcionPartidaLarga: string;
}

export class ClsConceptosPartida {
  IdPresupuestoPartida?: bigint;
  IdPresupuestoPartidaS?: string;
  Partida: string;
  IdCatalogo?: bigint;
  IdCatalogoS?: string;
  Renglon?: number;
  Control: number;
  Codigo: string;
  Descripcion?: string;
  DescripcionLarga: string;
  TipoInsumo: number;
  Unidad: string;
  Marca: boolean;
  Nivel: number;
  CodigoAuxiliar?: string;
  IndirectoEspecial: boolean;
  PorcentajeIndirectoEspecial: number;
  Cantidad: number;
  CostoMoneda1: number;
  PrecioMoneda1: number;
  CostoMoneda2: number;
  PrecioMoneda2: number;
  ImporteMoneda1: number;
  ImporteMoneda2: number;
  UrlContenido: string;
  PendienteAnalizar?: boolean;
  ObservacionPendiente?: string;
  EsPorcentaje: number;
  EsCostoHorario: boolean;
}

export class ClsConceptosSeleccionados {
  IdPresupuestoPartida?: bigint;
  IdPresupuestoPartidaS?: string;
  Conceptos: ClsConceptosPartida[];
}

export class ClsUnirPpto {
  IdPartidaPadre: bigint;
  IdPresupuestoPartida: bigint;
  Partida: string;
  Descripcion: string;
  DescripcionCompleta: string;
  EsNuevo: boolean;
  Renglon: number;
  Conceptos: ClsGuardarConceptosPartida[];
}

// Estructura del nodo resultante en el árbol
export class ClsArbolNodo extends ClsArbolPartida {
  EsNuevo?: boolean;
  Children?: ClsArbolNodo[]; // Array de sub-nodos (hijos)
}
export class ClsRenumerarRenglon {
  IdPresupuestoPartida: bigint;
  IdPartidaPadre: bigint;
  Renglon: number;
  JsonConceptos?: any;
}
